import { render } from "./Group232.vue?vue&type=template&id=02354388"
import script from "./Group232.vue?vue&type=script&lang=js"
export * from "./Group232.vue?vue&type=script&lang=js"

import "./Group232.vue?vue&type=style&index=0&id=02354388&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__